<script setup>
import { ref, computed } from "vue";
import availableNumbers from './availableNumbers.vue';
import { __, isNumber } from '@/utils';

const PREFIX_OPTIONS = ['055-442', '055-460'];
const selectedPrefix = ref(PREFIX_OPTIONS[0]);
const clickedNumber = ref('');

const availabilityCheck = ref(true);
const isAvailable = ref(false);
const availbilityLoading = ref(false);
const accept = ref(false);
const cancle = ref(false);
const numberSufix = ref('');

const emit = defineEmits(['cancelNumber', 'clickAcceptNumber', 'removeUnsaved'])

const computedNumber = computed(() => selectedPrefix.value + numberSufix.value)
const phone_id = ref('');

const props = defineProps({
	index: Number,
});

const resetAvailabilityState = () => {
	availabilityCheck.value = true;
	accept.value = false;
	isAvailable.value = false;
	cancle.value = false;
}

const handleClick = (number) => {
	const suffix = number.slice(-4);
	selectedPrefix.value = number.slice(0, -4);
	clickedNumber.value = number;
	numberSufix.value = suffix;
	resetAvailabilityState();
	emit('clickAcceptNumber', { computedNumber: number, index: props.index });
}

const handleInput = () => {
	numberSufix.value = numberSufix.value.slice(-4);
	resetAvailabilityState();
}

const handlePrefixChange = () => {
	resetAvailabilityState();
}

const checkMsisdns = () => {

	let number = computedNumber.value;
	number = number.replace('-', '');
	availbilityLoading.value = true;

	fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=check_number_availability&number=${number}`,
	})
		.then(response => response.json())
		.then(data => {
			emit('removeUnsaved', props.index)
			const apiResponse = JSON.parse(data.data);
			if (apiResponse.response.phone_id) {
				phone_id.value = apiResponse.response.phone_id;
				toggleIsActive();
			} else {
				toggleIsUnavailable();
			}
		})
		.catch(error => console.error('Error:', error))
		.finally(() => {
			availbilityLoading.value = false
		});
}

const toggleIsActive = () => {
	accept.value = true;
	cancle.value = true;
	isAvailable.value = false;
	availabilityCheck.value = false;
}

const toggleIsUnavailable = () => {
	cancle.value = true;
	accept.value = false;
	isAvailable.value = true
	availabilityCheck.value = false;
}
</script>
<template>
	<div class="controls">
		<div class="controls__body">
			<div class="controls__field">
				<div class="field">
					<label for="phone-2" >{{ __('Type desired number') }}</label><!-- /.form__label -->

					<div class="field-overwrite">
						<select
							v-model="selectedPrefix"
							class="field__prefix field__prefix-select"
							@change="handlePrefixChange"
						>
							<option v-for="prefix in PREFIX_OPTIONS" :key="prefix" :value="prefix">
								{{ prefix }}
							</option>
						</select>
						<input
							type="text"
							class="field field-number-sufix field--no-styles"
							placeholder="0000"
							v-model="numberSufix"
							@keypress="isNumber($event)"
							@input="handleInput"
						>
					</div>
				</div><!-- /.field -->
			</div><!-- /.controls__field -->

			<div class="controls__actions">
				<button
					class="btn"
					type="button"
					v-if="numberSufix !== '' && availabilityCheck"
					:disabled="availbilityLoading"
					@click="checkMsisdns"
				>
					<span>
						<img src="/resources/images/spinner.svg" alt="" v-if="availbilityLoading">
						{{ __('Availability check') }}
					</span>
				</button>

				<button class="link-underline cancel-link" v-if="index > 0" @click="$emit('cancelNumber', index)">
					{{ __('Cancel') }}
				</button>
			</div><!-- /.controls__actions -->
		</div><!-- /.controls__body -->

		<div class="controls__foot" v-if="isAvailable || accept">
			<div class="controls__error" v-if="isAvailable">
				{{ __('The Number is not Available') }}
			</div><!-- /.controls__error -->

			<template v-if="accept">
				<div class="controls__info">
					{{  __('The number you requested is available') }}
				</div><!-- /.controls__info -->

				<button class="btn" type="button"
					@click.prevent="$emit('clickAcceptNumber', { computedNumber, index, phone_id })">
					{{ __('Select this number') }}
				</button>
			</template>
		</div><!-- /.controls__foot -->
	</div><!-- /.controls -->

	<div class="available-numbers">
		<label class="available-numbers__title" for="phone-3">
			{{ __('Or choose one of the following numbers') }}
		</label><!-- /.form__label -->

		<availableNumbers @clickedNumber="handleClick" />
	</div>
</template>

